export const profileConstants = {
  GET_PROFILE_DETAILS_REQUEST: "GET_PROFILE_DETAILS_REQUEST",
  GET_PROFILE_DETAILS_COMPLETE: "GET_PROFILE_DETAILS_COMPLETE",
  GET_PROFILE_DETAILS_ERROR: "GET_PROFILE_DETAILS_ERROR",

  UPDATE_DISPLAY_NAME_REQUEST: "UPDATE_DISPLAY_NAME_REQUEST",
  UPDATE_DISPLAY_NAME_COMPLETE: "UPDATE_DISPLAY_NAME_COMPLETE",
  UPDATE_DISPLAY_NAME_ERROR: "UPDATE_DISPLAY_NAME_ERROR",

  UPDATE_PROFILE_PICTURE_REQUEST: "UPDATE_PROFILE_PICTURE_REQUEST",
  UPDATE_PROFILE_PICTURE_COMPLETE: "UPDATE_PROFILE_PICTURE_COMPLETE",
  UPDATE_PROFILE_PICTURE_ERROR: "UPDATE_PROFILE_PICTURE_ERROR",

  FACE_DETECT_INTERVAL_MS: 400,
  DEFAULT_FACE_MODEL_BASE_URL:
    "https://cdn.jsdelivr.net/gh/justadudewhohacks/face-api.js@v0.22.2/weights",
};
